import { Button, Modal, Trans } from '@/components'

interface DeleteImageModalProps {
  open: boolean
  imageId: number | null
  onClose: () => void
  onConfirm: (imageId: number) => void
}

export function DeleteImageModal({ open, imageId, onClose, onConfirm }: DeleteImageModalProps) {
  const handleConfirm = () => {
    if (imageId !== null) {
      onConfirm(imageId)
      onClose()
    }
  }

  if (!open) return null

  return (
    <Modal className="w-[640px]" open={true} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="customImage.deleteModal.title">Delete Custom Image</Trans>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Trans i18nKey="customImage.deleteModal.description">
            This action will permanently delete the selected custom image.
          </Trans>
        </div>
      </Modal.Body>
      <div>
        <div className="pt-4 flex items-end justify-end gap-4">
          <Button size="md" type="outline" className="min-w-[88px]" onClick={onClose}>
            <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
          </Button>
          <Button type="danger" size="md" className="min-w-[88px]" onClick={handleConfirm}>
            <Trans i18nKey="customImage.deleteModal.confirmButton">Delete</Trans>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
